import { Card, CardProps } from '@mui/material';
import React from 'react';

const StyCard = (props: Omit<CardProps, 'elevation'>): React.ReactElement => (
    <Card
        {...props}
        sx={{ borderRadius: '0.5rem', ...props?.sx }}
        elevation={0}
    />
);

export default StyCard;
